import { render } from "./FPSideNav.vue?vue&type=template&id=50210da2&ts=true"
import script from "./FPSideNav.ts?vue&type=script&lang=ts&external"
export * from "./FPSideNav.ts?vue&type=script&lang=ts&external"

import "./FPSideNav.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__